import { render } from "./ReviewCheckedItems.vue?vue&type=template&id=56ba2e1c&scoped=true"
import script from "./ReviewCheckedItems.vue?vue&type=script&lang=js"
export * from "./ReviewCheckedItems.vue?vue&type=script&lang=js"

import "./ReviewCheckedItems.vue?vue&type=style&index=0&id=56ba2e1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ba2e1c"]])

export default __exports__